import styles from "./Image.module.css";
function Image ({ src, alt }) {
    return (
        <div>
            <img src={src} alt={alt} className={styles.img}/>
        </div>
    )
}

export default Image